import { Action, createReducer, on } from '@ngrx/store';
import { PageViewEvent } from '@snowplow/browser-tracker-core';
import { CommonEventProperties } from '@snowplow/tracker-core';

import * as SnowplowActions from './snowplow.actions';
import { SnowplowConfiguration } from './snowplow.models';

export const SNOWPLOW_FEATURE_KEY = 'snowplow';

export interface SnowplowState {
  initialized: boolean;
  anonymized: boolean;
  latestPageView?: PageViewEvent & CommonEventProperties;
  configuration?: SnowplowConfiguration;
}

export interface SnowplowPartialState {
  readonly [SNOWPLOW_FEATURE_KEY]: SnowplowState;
}

export const initialSnowplowState: SnowplowState = {
  initialized: false,
  anonymized: true,
};

const reducer = createReducer(
  initialSnowplowState,
  on(SnowplowActions.initialize, (state, action) => ({
    ...state,
    configuration: action,
  })),
  on(SnowplowActions.pageView, (state, action) => ({
    ...state,
    latestPageView: action,
  })),
  on(SnowplowActions.anonymize, (state, action) => ({
    ...state,
    anonymized: action.anonymize,
  }))
);

export function snowplowReducer(state: SnowplowState | undefined, action: Action) {
  return reducer(state, action);
}
